import { ObsessedEngineeringComponentType, ObsessedEngineeringComponentUnit } from './obsessed-engineering-component.model';
import { ObsessedEngineeringOrderType } from './obsessed-engineering-order.model';

export enum ObsessedEngineeringInvoiceStatus {
    Draft = 'Draft',
    Released = 'Released',
}

export type ObsessedEngineeringInvoiceAdjustmentType = 'fee' | 'credit';

export interface ObsessedEngineeringInvoiceAdjustmentSnapshot {
    id: string;
    description: string;
    amountCents: number;
}

export type ObsessedEngineeringInvoiceFeeSnapshot = ObsessedEngineeringInvoiceAdjustmentSnapshot;
export type ObsessedEngineeringInvoiceCreditSnapshot = ObsessedEngineeringInvoiceAdjustmentSnapshot;

export interface ObsessedEngineeringInvoiceComponentSnapshot {
    componentId: string;
    partNumber: string;
    customerPartNumber: string;
    description: string;
    type: ObsessedEngineeringComponentType;
    units: ObsessedEngineeringComponentUnit;
    quantityPerProduct: number;
    manufacturingUnitCents: number | null;
}

export interface ObsessedEngineeringInvoiceLineSnapshot {
    orderedProductId: string;
    productVersionId: string;
    versionNumber: number | null;
    partNumber: string;
    customerPartNumber: string;
    description: string;
    quantity: number;
    manufacturingUnitCents: number;
    assemblyUnitCents: number;
    pickingUnitCents: number;
    manufacturingCents: number;
    assemblyCents: number;
    pickingCents: number;
    components: ObsessedEngineeringInvoiceComponentSnapshot[];
}

export interface ObsessedEngineeringInvoiceSnapshot {
    orderId: string;
    orderNumber: string;
    orderType: ObsessedEngineeringOrderType;
    customerPurchaseOrderNumber: string;
    invoiceDate: string;
    seljanAddressInfo: string;
    oeAddressInfo: string;
    lines: ObsessedEngineeringInvoiceLineSnapshot[];
    fees: ObsessedEngineeringInvoiceFeeSnapshot[];
    credits: ObsessedEngineeringInvoiceCreditSnapshot[];
    manufacturingCents: number;
    assemblyCents: number;
    pickingCents: number;
    totalQuantity: number;
}

export interface ObsessedEngineeringInvoice {
    id: string;
    orderId: string;
    revisionNumber: number;
    status: ObsessedEngineeringInvoiceStatus;
    releaseKey?: string | null;
    snapshot: ObsessedEngineeringInvoiceSnapshot;
    invoicePdfFileId: string;
    invoicePdfDownloadUrl: string;
    createdOn: Date;
    createdById: string;
    releasedOn: Date | null;
    releasedById: string;
}
